import styled from 'styled-components';
import {
  white,
  smallContainerWidth,
  orange,
  darkWhite,
  darkOrange,
  lightOrange,
} from '../../constants/theme';

import { Modal } from 'reactstrap';

export const ModalFind = styled(Modal)`
  width: 100%;
  max-width: 100%;
  margin: 0;
  .modal-content {
    border: none;
    border-radius: 0;
  }
`;

export const ContainerCss = styled.header`
  background-color: ${white};
  width: 100%;
  margin: 0 auto !important;
  align-items: center;
  text-align: center;
  padding: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.05);
  .last {
    background-color: ${orange};
    color: ${white};
    font-weight: bold;
    padding: 12px 30px;
    border: none;
    &:hover {
      color: ${darkWhite};
      background-color: ${darkOrange};
    }
    &:active,
    &:focus {
      background-color: ${darkOrange};
      outline: none;
    }
  }
  .header-container {
    width: 100%;
    max-width: ${smallContainerWidth};
    margin: 0 auto !important;
  }
  .row {
    width: 100%;
    justify-content: flex-end;
    align-items: center;
    margin-left: 0;
    height: 106px;
  }
  .header-logo {
    width: 124px;
    align-items: center;
    & > img {
      display: none;
    }
  }
  .col-items {
    padding-right: 0;
    &.tablet {
      display: none;
    }
    &.desktop {
      display: block;
    }
  }
  .col-logo {
    padding: 0;
  }

  @media screen and (max-width: 1024px) {
    .header-logo {
      text-align: center;
      width: 85px;
      display: inline-block;
      margin: 15px;
      
    }

    .row {
      flex-direction: row;
      width: 100%;
      margin-left: 0;
      height: 80px;
    }
    .col-logo-tablet {
      position: absolute;
      top: 0;
      right: 33%
      width: 33%;
    }
    .col-items {
      padding: 0;
      &.desktop {
        display: none;
      }
      &.tablet {
        position: absolute;
        top: 27px;
        width: 25%;
        right: 16px;
        display: block;
        text-align: right;
      }
      &.menu-icon {
        // width:33%;
      }
      svg {
        color: ${lightOrange};
        font-size: 27px;
      }
    }
  }
  @media (min-width: 766px) and (max-width: 1024px) {
    .col-logo-tablet {
      position: absolute;
      top: 0;
      right: 33%;
      width: 33%;
    }
  }

  @media (min-width: 766px) and (max-width: 1024px) and (orientation: landscape) {
    .col-items {
      max-width: 100%;
      flex: 0 0 100% !important;
      width: 100%;
    }
    .col-logo-tablet {
      position: absolute;
      top: 0;
      right: 42%;
      width: 33%;
    }
  }
  @media (min-width: 320px) and (max-width: 767px) and (orientation: landscape) {
    .col-logo-tablet {
      position: absolute;
      top: 0;
      right: 33%;
      width: 33%;
    }
  }
  //Ipad Pro 
  @media only screen 
  and (min-width: 1024px) 
  and (max-height: 1366px) 
  and (orientation: portrait) 
  and (-webkit-min-device-pixel-ratio: 1.5) {
    .col-items {
      max-width: 100%;
      flex: 0 0 100%;
    }
    .col-logo-tablet {
      right: 42%;
    }
  }

`;

export const SearchComp = styled.div`
  h2 {
    display: none;
  }
  .card {
    border: none;
    padding: 20px 0 0 0;
    border-radius: 0;
  }
  .modal-find-trial {
    color: red;
    width: 100%;
    max-width: 100%;
    div {
      border: none;
    }
  }
  @media (max-width: 1024px) {
    .card {
      padding: 0;
    }
    .more-button {
      margin-bottom: 80px !important;
    }
  }
`;
